import { ProviderType } from "./ObjectTypes";
import { checkSchema } from "./SchemaFormTemplates/checkSchema";

export type ConnectionKind = "webhook" | "push-only" | "standard";

export function getConnectionKind(providerType: ProviderType): ConnectionKind {
    const hasPullConfig = providerType.actions
        ?.filter((a) => a.type !== "push")
        .some((a) => checkSchema(a));
    if (hasPullConfig) return "standard";
    if (providerType.value === "generic_webhooks") return "webhook";
    return "push-only";
}

export function providerHasPushAction(providerType: ProviderType): boolean {
    return providerType.actions?.some((a) => a.type === "push") ?? false;
}
